// extracted by mini-css-extract-plugin
export default {"skill_card":"SkillCard_skill_card__JlmXc","skill_card_title":"SkillCard_skill_card_title__MborR"};